import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Button,
  Spinner,
  Accordion,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  useCancelOrderMutation,
  useChangeGroupedOrderStatusMutation,
  useChangeMealStatusMutation,
  useGetGroupedOrderInfoQuery,
  useGetGroupedSingleOrderInfoQuery,
  useGetOrderDetailsQuery,
  useGetOrderNewQuery,
  useUpdateOrderMutation,
} from "../../../../store/services/orderService";
import moment from "moment";
import toast from "react-hot-toast";
import styles from "./orderDetail.module.scss";
import {
  macrosBarDynamicPercentage,
  priceCurrency,
} from "../../../../helpers/common";
import OrderMealDetail from "../../../../components/Modals/OrderMealDetail";
import DatesHeader from "../DatesHeader";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";

// Function to format the date array into the desired format
const formatDateArray = (dateArray) => {
  // Use Set to get unique dates
  const uniqueDates = [...new Set(dateArray)];

  return uniqueDates.map((dateStr) => {
    const date = moment(dateStr);
    return {
      day: date.format("dddd"), // Day of the week
      dateLabel: date.format("DD/MM"), // Date in "DD/MM" format
      date: date.toISOString(), // ISO format date
    };
  });
};

const OrderDetailSingle = () => {
  const { id } = useParams();
  // const {
  //   data: order,
  //   error,
  //   isLoading,
  // } = useGetOrderDetailsQuery({
  //   pageNo: 1,
  //   limit: 10,
  //   orderBy: "createdAt",
  //   order: -1,
  //   // "status": "confirmed",
  //   // "search": "order123",
  //   orderId: id,
  // });
  const {
    data: order,
    error,
    isLoading,
  } = useGetGroupedSingleOrderInfoQuery({
    pageNo: 1,
    limit: 10,
    orderBy: "createdAt",
    order: 1,
    // "status": "confirmed",
    // "search": "order123",
    groupId: id,
  });

  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [selectedMealStatus, setSelectedMealStatus] = useState(null);
  const [updateOrder, { isLoading: isUpdating }] = useCancelOrderMutation();
  const [updateMealStatus, { isLoading: isUpdatingMealStatus }] =
    useChangeMealStatusMutation();
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [
    updateGroupedOrderStatus,
    { isLoading: isUpdatingGroupedOrderStatus },
  ] = useChangeGroupedOrderStatusMutation();
  const [activeButton, setActiveButton] = React.useState(null);

  const [confirmationGroupOrderStatus, setConfirmationGroupOrderStatus] =
    useState(false);
  const [
    confiramtionGroudOrderStatusData,
    setConfirmationGroupOrderStatusData,
  ] = useState(null);

  // Function to handle status update
  // const handleStatusUpdate = async (status) => {
  //   try {
  //     await updateOrder({
  //       userId: id, // Pass the order ID
  //       updatedData: { status }, // Pass the status to update
  //     }).unwrap(); // Await API response
  //     toast.success(`Order status updated to '${status}' successfully`);
  //   } catch (error) {
  //     console.error("Failed to update the order:", error);
  //     toast.error("Failed to update the order. Please try again.");
  //   }
  // };

  const handleStatusUpdate = async () => {
    try {
      const res = await updateOrder({
        orderId: id, // Pass the order ID
        status: "cancelled",
        cancelledAt: new Date(),
      }).unwrap(); // Await API respons
      toast.success(res?.message);
    } catch (error) {
      console.error("Failed to update the order:", error);
      toast.error("Failed to update the order. Please try again.");
    } finally {
      setCancelConfirmation(false);
    }
  };
  useEffect(() => {
    if (selectedDay) {
      const preparingDates = selectedDay?.meals?.map(
        (item) => item.preparingDate
      );
      const dates = formatDateArray(preparingDates);

      setDates(dates);
      if (!selectedDate) {
        setSelectedDate(dates?.[0]?.date); // Set the first date if no date is selected
      } else if (!dates?.some((d) => d.date === selectedDate)) {
        setSelectedDate(dates?.[0]?.date); // Set the first date if selectedDate is not in the list
      } else {
        console.log("in else");
      }
    }
  }, [selectedDay]);
  useEffect(() => {
    if (order?.data?.meals?.length > 0) {
      const firstOrder =
        selectedDay === null
          ? order?.data?.meals[0]
          : order?.data?.meals?.find(
              (it) => it.subOrderID === selectedDay?.subOrderID
            );

      setSelectedDay(firstOrder);
    }
  }, [order]);

  const selectedMealsInfo = useMemo(() => {
    if (!selectedDay || !selectedDate) return [];

    // Filter meals based on the selected dates
    return (
      selectedDay?.meals?.filter((item) =>
        moment(item?.preparingDate).isSame(selectedDate, "day")
      ) || []
    );
  }, [selectedDay, selectedDate]);

  useEffect(() => {
    setSelectedMeals(selectedMealsInfo);
  }, [selectedMealsInfo]);

  console.log("orderDetailData==>>>", order);
  console.log("selectedDay ====>", selectedDay);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Something went wrong</div>;
  // }

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  const handleChangeStatus = async (status) => {
    try {
      const resp = await updateMealStatus({
        id: selectedMealStatus?._id,
        data: { status: "prepared", preparedAt: new Date() },
      }).unwrap();

      toast.success(resp.message);
      setConfirmation(false);
    } catch (error) {}
  };

  const handleGroupedOrderStatus = async () => {
    try {
      const { _id, ...rest } = confiramtionGroudOrderStatusData;
      const resp = await updateGroupedOrderStatus({
        id: _id,
        data: {
          ...rest,
        },
      }).unwrap();

      toast.success(resp.message);
      setConfirmationGroupOrderStatus(false);
      setConfirmationGroupOrderStatusData(null);
    } catch (error) {}
  };

  const renderButton = (selectedDay) => {
    switch (selectedDay?.status) {
      case "confirmed":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            onClick={() => {
              setConfirmationGroupOrderStatusData({
                status: "inTransit",
                intransitAt: new Date(),
                _id: selectedDay._id,
              });
              setConfirmationGroupOrderStatus(true);
            }}
            disabled={isUpdatingGroupedOrderStatus}
          >
            Mark the order as 'In Transit'
          </Button>
        );
      case "inTransit":
        return (
          <>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn"
              onClick={() => {
                setConfirmationGroupOrderStatusData({
                  status: "delivered",
                  deliveredAt: new Date(),
                  _id: selectedDay._id,
                });
                setConfirmationGroupOrderStatus(true);
              }}
              disabled={isUpdatingGroupedOrderStatus}
            >
              Mark the order as 'Delivered'
            </Button>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn ml-2"
              disabled
            >
              Order is currently 'In Transit'
            </Button>
          </>
        );
      case "delivered":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            Order is already marked as 'Delivered'
          </Button>
        );
      case "paused":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is paused
          </Button>
        );
      case "cancelled":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is cancelled
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={handleChangeStatus}
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmationGroupOrderStatus}
        setConfirmation={setConfirmationGroupOrderStatus}
        confirmHandler={handleGroupedOrderStatus}
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={cancelConfirmation}
        setConfirmation={setCancelConfirmation}
        confirmHandler={handleStatusUpdate}
      />
      {modalOpen && (
        <OrderMealDetail
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title={selectedMeal?.name}
          meal={selectedMeal}
        />
      )}
      <section className={`${styles.ordersec} py-5 position-relative`}>
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/orders"
                  className="border d-flex align-align-align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Order Detail 
                </h4>
              </div>
            </Col>
            {isLoading && (
              <div className="text-center">
                <div className="spinner-border text-dark" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </Row>
          {!isLoading && (
            <Row className="mx-auto" style={{ maxWidth: 1024 }}>
              {order?.data?.order?.status === "paused" &&
                order?.data?.order?.pausedAt && (
                  <Col lg="12">
                    <div className="alert alert-danger" role="alert">
                      This order has been paused from{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      )}{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      ) === 1
                        ? "day"
                        : "days"}
                      .{/* Please contact the customer. */}
                    </div>
                  </Col>
                )}
              <Col lg="12" className="my-2">
                <div className="mx-auto">
                  <div className="cardCstm bg-light rounded-3 p-2 px-3">
                    <div className="top p-2 d-d-flex align-align-align-items-center justify-content-between border-bottom  d-d-flex-wrap">
                      <h5 className="m-0 fw-sbold">Order List</h5>
                      <p className="m-0 text-muted">
                        {" "}
                        Order Id : {order?.data?.order?.orderID}
                      </p>
                    </div>
                    <div className="contentBody">
                      <Row>
                        <Col sm="2" className="my-2">
                          <Accordion defaultActiveKey="0">
                            {order?.data?.meals?.length > 0 &&
                              order?.data?.meals?.map((item, index) => (
                                <Accordion.Item
                                  // className={`${styles.accordionItm} ${item?.status == "" } bg-danger bg-success bg-warning `}
                                  className={`${styles.accordionItm} ${
                                    item?.status === "cancelled"
                                      ? "bg-danger"
                                      : item?.status === "confirmed"
                                      ? "bg-success"
                                      : item?.status === "delivered"
                                      ? "bg-primary"
                                      : item?.status === "paused"
                                      ? "bg-secondary"
                                      : item?.status === "onTheWay"
                                      ? "bg-info"
                                      : item?.status === "inTransit"
                                      ? "bg-warning"
                                      : "bg-warning"
                                  }`}
                                  eventKey={index.toString()}
                                  key={item?.week}
                                >
                                  <Accordion.Header
                                    className={`${styles.accordionHeader}`}
                                  >
                                    {/* {`Order ${index + 1}`} */}
                                    {`Delivery date ${
                                      item?.subOrderID || index + 1
                                    }`}
                                  </Accordion.Header>
                                  <Accordion.Body className="px-1 py-0">
                                    <ul className="list-unstyled ps-0 mb-0">
                                      {/* {item?.preparingDates?.length > 0 &&
                                        item?.preparingDates.map(
                                          (date, idx) => ( */}
                                      <li className="py-2">
                                        <div
                                          className={`text-center position-relative p-2 rounded cursor-pointer ${
                                            moment(
                                              selectedDay?.deliveryDate
                                            )?.format("YYYY-MM-DD") ===
                                            moment(item?.deliveryDate)?.format(
                                              "YYYY-MM-DD"
                                            )
                                              ? "bg-[#3E0799] text-white"
                                              : "text-gray-400"
                                          }`}
                                          style={{
                                            background:
                                              moment(
                                                selectedDay?.deliveryDate
                                              )?.format("YYYY-MM-DD") ===
                                              moment(
                                                item?.deliveryDate
                                              )?.format("YYYY-MM-DD")
                                                ? "#3E0799"
                                                : "",
                                          }}
                                          onClick={() => setSelectedDay(item)}
                                        >
                                          <h6 className="m-0 fw-sbold py-1">
                                            {moment(item?.deliveryDate).format(
                                              "dddd"
                                            )}
                                          </h6>
                                          <p className="m-0">
                                            {moment(item?.deliveryDate).format(
                                              "DD/MM"
                                            )}
                                          </p>
                                        </div>
                                      </li>
                                      {/* )
                                        )} */}
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              ))}
                          </Accordion>
                        </Col>
                        <Col sm="10" className="my-2">
                          <Row>
                            <Col lg="12">
                              <div className="d-flex align-items-center justify-content-between  text-end">
                                <div>
                                  Status :{" "}
                                  <span className="text-[#3E0799] fw-bold text-uppercase">
                                    {selectedDay?.status}
                                  </span>
                                </div>
                                <div>
                                  Sub order ID :{" "}
                                  <span className="text-[#3E0799] fw-bold text-uppercase">
                                    {selectedDay?.subOrderID}
                                  </span>
                                </div>
                                {renderButton(selectedDay)}
                              </div>
                            </Col>
                            <Col sm="10" className="my-2">
                              <DatesHeader
                                selectedDate={selectedDate}
                                dates={dates}
                                canSwitchDate={true}
                                setSelectedDate={setSelectedDate}
                                arrowShow={false}
                              />
                            </Col>
                            {selectedMeals?.length > 0 &&
                              selectedMeals.map((meal, index) => {
                                const totalOfMacros =
                                  (meal?.macros?.carbs || 0) +
                                  (meal?.macros?.protein || 0) +
                                  (meal?.macros?.fat || 0);
                                return (
                                  <Col sm="4" key={index}>
                                    <h6 className="m-0 py-2 text-center fw-sbold text-dark ">
                                      {meal?.mealType} Meal
                                    </h6>
                                    <div
                                      className={`${styles.cardCstm}  cardCstm border rounded`}
                                    >
                                      <div className="imgWrp">
                                        <img
                                          src={meal?.image}
                                          alt=""
                                          loading="lazy"
                                          width={1000}
                                          height={10000}
                                          decoding="async"
                                          className="w-full img-fluid object-fit-cover"
                                          style={{
                                            height: 150,
                                            color: "transparent",
                                            borderTopLeftRadius: 5,
                                            borderTopRightRadius: 5,
                                          }}
                                        />
                                      </div>
                                      <div className="contentBody">
                                        <h6 className="m-0 fw-sbold  p-2 pb-1">
                                          {meal?.name}
                                        </h6>
                                        <div
                                          className=" p-2"
                                          style={{
                                            background: "rgb(249, 248, 255)",
                                          }}
                                        >
                                          <p className="m-0 fw-sbold pb-1 text-dark">
                                            {meal?.macros?.calories} Calories
                                          </p>
                                          <ul className="list-unstyled text-center pl-0 mb-0 d-flex items-start justify-content-center">
                                            <li
                                              className=""
                                              style={{
                                                width: `${macrosBarDynamicPercentage(
                                                  meal?.macros?.carbs,
                                                  totalOfMacros
                                                )}%`,
                                                minWidth: 35,
                                              }}
                                            >
                                              <div
                                                data-tooltip-id="cpf"
                                                data-tooltip-content="164g"
                                                className=" mb-1 w-100 cursor-pointer"
                                                style={{
                                                  background:
                                                    "rgb(173, 21, 14)",
                                                  height: 4,
                                                }}
                                              />
                                              <div
                                                className="content"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: "12px",
                                                }}
                                              >
                                                <p className="m-0 text-dark">
                                                  {meal?.macros?.carbs}g
                                                </p>
                                                <p className="m-0  text-muted">
                                                  Carbs
                                                </p>
                                              </div>
                                            </li>
                                            <li
                                              className=""
                                              style={{
                                                width: `${macrosBarDynamicPercentage(
                                                  meal?.macros?.protein,
                                                  totalOfMacros
                                                )}%`,
                                                minWidth: 35,
                                              }}
                                            >
                                              <div
                                                data-tooltip-id="cpf"
                                                data-tooltip-content="123g"
                                                className=" mb-1 w-100 cursor-pointer"
                                                style={{
                                                  background:
                                                    "rgb(245, 181, 62)",
                                                  height: 4,
                                                }}
                                              />
                                              <div
                                                className="content"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: "12px",
                                                }}
                                              >
                                                <p className="m-0 text-dark">
                                                  {meal?.macros?.protein}g
                                                </p>
                                                <p className="m-0 text-muted">
                                                  Protein
                                                </p>
                                              </div>
                                            </li>
                                            <li
                                              className=""
                                              style={{
                                                width: `${macrosBarDynamicPercentage(
                                                  meal?.macros?.fat,
                                                  totalOfMacros
                                                )}%`,
                                                minWidth: 35,
                                              }}
                                            >
                                              <div
                                                data-tooltip-id="cpf"
                                                data-tooltip-content="55g"
                                                className=" mb-1 w-100 cursor-pointer"
                                                style={{
                                                  background:
                                                    "rgb(16, 140, 152)",
                                                  height: 4,
                                                }}
                                              />
                                              <div
                                                className="content"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: "12px",
                                                }}
                                              >
                                                <p className="m-0 text-dark">
                                                  {meal?.macros?.fat}g
                                                </p>
                                                <p className="m-0 text-muted">
                                                  Fat
                                                </p>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <h6 className="price p-2 text-base text-center fw-sbold">
                                          {priceCurrency(
                                            meal?.price || meal?.mealPrice
                                          )}
                                        </h6>
                                        {/* <h6 className="price p-2 text-base text-center fw-sbold">
                                          Date:{" "}
                                          {moment(meal?.preparingDate).format(
                                            "dddd, DD MMM"
                                          )}
                                        </h6> */}
                                        <div className="pt-1 btnWrpper px-2">
                                          <button
                                            className={`${styles.submitBtn} d-flex align-align-items-center fw-normal justify-content-center btn w-100`}
                                            onClick={() => {
                                              setSelectedMeal(meal);
                                              setModalOpen(true);
                                            }}
                                          >
                                            Details
                                          </button>
                                        </div>
                                        {(meal?.status === "confirmed" ||
                                          meal.status === "prepared" ||
                                          meal?.status === "swapped") && (
                                          <div className="pt-1 btnWrpper px-2">
                                            <button
                                              className={`${
                                                meal?.status === "prepared"
                                                  ? "btn-success"
                                                  : styles.submitBtn
                                              } d-flex align-align-items-center fw-normal justify-content-center btn w-100 `}
                                              onClick={() => {
                                                handleConfirmation();
                                                setSelectedMealStatus(meal);
                                              }}
                                              disabled={
                                                isUpdatingMealStatus ||
                                                meal?.status === "prepared"
                                              }
                                            >
                                              {meal?.status === "prepared"
                                                ? "Marked Prepared"
                                                : "Mark Prepared"}
                                            </button>
                                          </div>
                                        )}
                                        {meal?.status === "cancelled" && (
                                          <div className="pt-1 btnWrpper px-2">
                                            <button
                                              className={`${styles.submitBtn} d-flex align-align-items-center fw-normal justify-content-center btn w-100`}
                                              disabled={true}
                                            >
                                              Order is cancelled
                                            </button>
                                          </div>
                                        )}
                                        {meal?.status === "paused" && (
                                          <div className="pt-1 btnWrpper px-2">
                                            <button
                                              className={`${styles.submitBtn} d-flex align-align-items-center fw-normal justify-content-center btn w-100`}
                                              disabled={true}
                                            >
                                              Order is paused
                                            </button>
                                          </div>
                                        )}
                                        {meal?.status === "delivered" && (
                                          <div className="pt-1 btnWrpper px-2">
                                            <button
                                              className={`${styles.submitBtn} d-flex align-align-items-center fw-normal justify-content-center btn w-100`}
                                              disabled={true}
                                            >
                                              Order is delivered
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row>
                            {/* Free Products Section - Only show when freeProducts array has values */}
                      {(() => {
                        // Decide the source of free products based on order type
                        const orderType = order?.data?.order?.type;
                        const firstSubOrder = order?.data?.meals?.[0];
                        let allFreeProducts = [];

                        if (orderType === 2) {
                          // Product-only orders contain free products directly on the order object
                          allFreeProducts = order?.data?.order?.freeProducts || [];
                        } else {
                          // Meal-based orders: free products are attached at sub-order level
                          allFreeProducts = firstSubOrder?.freeProducts || [];
                        }

                        // Decide visibility: show always for product-only orders (type 2)
                        // For orders with meals (type 3/others), show ONLY on the first sub-order's first date
                        let shouldShow = false;
                        if (orderType === 1) {
                          shouldShow = true;
                        } else {
                          const isFirstSubOrderSelected =
                            selectedDay?.subOrderID === firstSubOrder?.subOrderID;

                          const firstSubOrderFirstDate = (() => {
                            const mealDates = (firstSubOrder?.meals || []).map((m) => m?.preparingDate);
                            if (!mealDates?.length) return null;
                            return moment(mealDates[0]).toISOString();
                          })();

                          const isFirstDateSelected =
                            !!selectedDate &&
                            !!firstSubOrderFirstDate &&
                            moment(selectedDate).isSame(firstSubOrderFirstDate, "day");

                          shouldShow = isFirstSubOrderSelected && isFirstDateSelected;
                        }

                        // Only render if we have free products and visibility rule passes
                        if (allFreeProducts.length > 0 && shouldShow) {
                          return (
                            <Row>
                              <Col lg="12" className="my-3">
                                <h6 className="m-0 py-2 text-center fw-sbold text-dark">
                                  Free Products (Promo Code Applied)
                                </h6>
                                <Row>
                                  {allFreeProducts?.map((product, index) => {
                                    // Get product details - handle both object and string references
                                    const productDetails =
                                      typeof product.productId === "object"
                                        ? product.productId
                                        : { name: "Product" };
                                    const flavourDetails =
                                      typeof product.flavourId === "object"
                                        ? product.flavourId
                                        : { name: "Flavour" };
                                    const sizeDetails =
                                      typeof product.sizeId === "object"
                                        ? product.sizeId
                                        : { name: "Size" };

                                    return (
                                      <Col sm="4" key={index}>
                                        <div
                                          className={`${styles.cardCstm} cardCstm border rounded`}
                                          style={{
                                            border: "2px solid #28a745",
                                          }}
                                        >
                                          <div className="imgWrp">
                                            <img
                                              src={
                                                flavourDetails?.images?.[0] ||
                                                productDetails?.image ||
                                                "https://via.placeholder.com/300x200?text=Product"
                                              }
                                              alt=""
                                              loading="lazy"
                                              width={1000}
                                              height={10000}
                                              decoding="async"
                                              className="w-full img-fluid object-fit-cover"
                                              style={{
                                                height: 150,
                                                color: "transparent",
                                                borderTopLeftRadius: 5,
                                                borderTopRightRadius: 5,
                                              }}
                                            />
                                          </div>
                                          <div className="contentBody">
                                            <h6 className="m-0 fw-sbold p-2 pb-1">
                                              {productDetails?.name}
                                            </h6>
                                            <h6 className="price p-2 text-base text-center fw-sbold text-success">
                                              FREE
                                            </h6>
                                            <div className="pt-1 pb-2 btnWrpper px-2">
                                              <div className="py-1">
                                                <button
                                                  className={`${styles.submitBtn} d-flex align-items-center fw-bold justify-content-center btn w-100`}
                                                  disabled
                                                >
                                                  Qty: {product.quantity}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                    );
                                  })}
                                </Row>
                              </Col>
                            </Row>
                          );
                        }
                        return null;
                      })()}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="6" className="my-2">
                <div className="cardCstm bg-light rounded-3 p-2 px-3 mb-3">
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Spicy Level
                        </h6>
                        {order?.data?.order?.spicyLevel || "No data found!"}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Customer Name
                        </h6>
                        {order?.data?.order?.deliveryAddress?.fullName}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Phone Number
                        </h6>
                        {order?.data?.order?.deliveryAddress?.phoneNumber}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Delivery Address
                        </h6>
                        <p className="m-0 text-gray-500">
                          {order?.data?.order?.deliveryAddress?.houseNo},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine1},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine2},{" "}
                          {order?.data?.order?.deliveryAddress?.emirates},{" "}
                          {order?.data?.order?.deliveryAddress?.country},{" "}
                          {/* {order?.data?.order?.deliveryAddress?.state},{" "} */}
                        </p>

                        {/* <p className="m-0 text-gray-500">
                          <Link to={order?.data?.order?.deliveryAddress?.locationUrl} target="_blank">
                            {order?.data?.order?.deliveryAddress?.location}
                          </Link>
                        </p> */}
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Location
                        </h6>
                        <p className="m-0 text-gray-500">
                          <Link
                            to={
                              order?.data?.order?.deliveryAddress?.locationUrl
                            }
                            target="_blank"
                          >
                            {order?.data?.order?.deliveryAddress?.location}
                          </Link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btnWrpper mt-2">
                  <button
                    className={`${styles.borderedBtn} d-flex align-items-center justify-content-center w-100 btn`}
                    type="button"
                    onClick={() => setCancelConfirmation(true)}
                    disabled={
                      isUpdating || order?.data?.order?.status === "cancelled"
                    }
                  >
                    {order?.data?.order?.status === "cancelled" ? (
                      <span className="text-gray-500">Order Cancelled</span>
                    ) : (
                      "Cancel Order"
                    )}
                  </button>
                </div>
              </Col>
              <Col md="6" className="my-2">
                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <div className="top pb-2">
                    <h6 className="m-0 fw-sbold text-base pb-1">
                      Order Summary
                    </h6>
                  </div>
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 d-flex align-items-center justify-content-between">
                          <p className="m-0 fw-normal text-dark text-base">
                            Meal Plan Price <br /> (incl. vat)
                          </p>
                          <p className="m-0 fw-normal text-dark text-base">
                            {priceCurrency(
                              order?.data?.order?.originalSubTotal
                            )}
                          </p>
                        </li>
                        {order?.data?.order?.isLongTermApplied && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {
                                      order?.data?.order?.planDurationDetails
                                        ?.label
                                    }{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.longTermDiscountValue
                                    )}
                                    {/* calculate percentage and show  */}(
                                    {`${order?.data?.order?.planDurationDetails?.discount}%`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Discounted Price
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {priceCurrency(
                                  order?.data?.order?.longTermDiscount
                                )}
                              </p>
                            </li>
                          </>
                        )}
                        {order?.data?.order?.isPromo && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {order?.data?.order?.couponDetail?.code}{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.discountPrice
                                    )}{" "}
                                    (
                                    {/* {order?.data?.order?.couponDetail
                                      ?.discountType === "Percent"
                                      ? `${order?.data?.order?.couponDetail?.discountValue}%`
                                      : `AED ${order?.data?.order?.couponDetail?.discountValue}`} */}
                                    {/* {order?.data?.order?.couponDetail && (
                                      `${order?.data?.order?.couponDetail.promoCodeType === "userReferral"
                                        ? order.data.order.couponDetail.referralDiscountForReferrer
                                        : order.data.order.couponDetail.discountValue
                                      } ${order.data.order.couponDetail.discountType === "Percent" ? "%" : "AED"}`
                                    )} */}
                                    {order?.data?.order?.couponDetail &&
                                      `${
                                        order?.data?.order?.couponDetail
                                          .promoCodeType === "userReferral" &&
                                        order?.data?.order?.userId ===
                                          order?.data?.order?.couponDetail
                                            ?.addedBy
                                          ? order.data.order.couponDetail
                                              .referralDiscountForReferrer
                                          : order.data.order.couponDetail
                                              .discountValue
                                      } ${
                                        order.data.order.couponDetail
                                          .discountType === "Percent"
                                          ? "%"
                                          : "AED"
                                      }`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Sub total
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {priceCurrency(
                                  order?.data?.order?.subTotalAfterPromo
                                )}
                              </p>
                            </li>
                          </>
                        )}
                        {order?.data?.order?.isAdvanceMacro && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Advanced Macro Fee
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(
                                order?.data?.order?.advanceMacroFees
                              )}
                            </p>
                          </li>
                        )}
                        <li className="py-2 d-flex align-items-center justify-content-between">
                          <p className="m-0 fw-normal text-dark text-base">
                            Delivery Fee
                          </p>
                          <p className="m-0 fw-normal text-dark text-base">
                            {priceCurrency(order?.data?.order?.deliveryFees)}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between">
                          <p className="m-0 fw-normal text-dark text-base">
                            Cooler Bag Deposit
                          </p>
                          <p className="m-0 fw-normal text-dark text-base">
                            {priceCurrency(order?.data?.order?.boxPrice)}
                          </p>
                        </li>
                        {order?.data?.order?.isSwaped && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 font-normal text-dark text-base">
                              Swapped Amount
                            </p>
                            <p className="m-0 font-normal text-dark text-base">
                              {/* {/ ${data?.order?.boxPrice} /} */}
                              {priceCurrency(order?.data?.order?.swapedAmount)}
                            </p>
                          </li>
                        )}
                      </ul>
                    </li>
                    <li className="py-2 border-bottom">
                      <div
                        className=" py-2 px-3 d-flex align-items-center justify-content-between"
                        style={{ background: "rgb(241, 241, 234)" }}
                      >
                        <p className="m-0 fw-sbold text-dark">Total Payment</p>
                        <p className="m-0 fw-sbold text-dark">
                          {" "}
                          {priceCurrency(order?.data?.order?.payAmount)}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};

export default OrderDetailSingle;

// return (
//   <section className="detail position-relative py-3 d-none">
//   <Container>
//     {isLoading && (
//       <div className="text-center">
//         <div className="spinner-border text-dark" role="status">
//           <span className="sr-only">Loading...</span>
//         </div>
//       </div>
//     )}

//     {!isLoading && order?.data && (
//       <Row>
//         <Col lg="12">
//           <div className="d-flex align-align-align-items-center gap-10">
//             <Link
//               to="/order-management"
//               className="border d-flex align-align-align-items-center p-2 rounded"
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="12"
//                 height="12"
//                 viewBox="0 0 10 16"
//                 fill="none"
//               >
//                 <path
//                   d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
//                   fill="#1E232C"
//                   stroke="#1E232C"
//                   stroke-width="0.2"
//                 />
//               </svg>
//             </Link>
//             <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
//               Order Detail
//             </h4>
//           </div>
//         </Col>

//         <Tab.Container
//           id="left-tabs-example"
//           defaultActiveKey="general-details"
//         >
//           <Nav
//             variant="pills"
//             className="inline-d-d-flex rounded-pill pillsTab"
//             style={{
//               background: "#033E8A",
//               maxWidth: "max-content",
//             }}
//           >
//             <Nav.Item>
//               <Nav.Link
//                 className="rounded-pill d-flex align-align-align-items-center justify-content-center position-relative"
//                 eventKey="general-details"
//               >
//                 General details
//               </Nav.Link>
//             </Nav.Item>
//             <Nav.Item>
//               <Nav.Link
//                 className="rounded-pill d-flex align-align-align-items-center justify-content-center position-relative"
//                 eventKey="recipe-details"
//               >
//                 Recipe & Cooking Details
//               </Nav.Link>
//             </Nav.Item>
//           </Nav>

//           <Tab.Content>
//             <Tab.Pane eventKey="general-details">
//               <Row>
//                 <Col lg="6" className="my-2">
//                   <label
//                     htmlFor=""
//                     className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
//                   >
//                     User Details
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0 noLastBorder">
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Name:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.userId?.name}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Mobile Number:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.userId?.mobileNumber}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Email:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.userId?.email}
//                         </p>
//                       </li>
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col lg="6" className="my-2">
//                   <label
//                     htmlFor=""
//                     className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
//                   >
//                     Meal Details
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0 noLastBorder">
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Name:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.name}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Order ID:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.orderID}
//                         </p>
//                       </li>
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col lg="6" className="my-2">
//                   <label
//                     htmlFor=""
//                     className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
//                   >
//                     Order Details
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0 noLastBorder">
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Meal Type:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                            {order?.data?.mealType}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Number of Items:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                            {order?.data?.quantity}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Total Price:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                            $ {order?.data?.price}
//                         </p>
//                       </li>
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col lg="6" className="my-2">
//                   <label
//                     htmlFor=""
//                     className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
//                   >
//                     Macros
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0 noLastBorder">
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Carbs:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.macros?.carbs}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">Fat:</p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.macros?.fat}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Protein:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.macros?.protein}
//                         </p>
//                       </li>
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col lg="6" className="my-2">
//                   <label
//                     htmlFor=""
//                     className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
//                   >
//                     Other Details
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0 noLastBorder">
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Created At:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {/* Feb 1, 2024 19:28 */}{" "}
//                           {moment(order?.data?.createdAt).format(
//                             "MMM D, YYYY"
//                           )}
//                         </p>
//                       </li>
//                       <li className="py-2 d-flex align-items-start">
//                         <p className="m-0 fw-sbold themeClr w-25">
//                           Status:
//                         </p>
//                         <p className="m-0 fw-sbold text-muted w-75">
//                           {order?.data?.status}
//                         </p>
//                       </li>
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col
//                   lg="6"
//                   className="my-2 d-flex justify-content-center align-align-align-items-center"
//                 >
//                   <div className="d-flex d-d-flex-column align-align-align-items-center">
//                     <div className="d-flex mt-2">
//                       <Button
//                         onClick={() => handleStatusUpdate("confirmed")}
//                         disabled={
//                           isUpdating || order?.status === "confirmed"
//                         }
//                         className="mx-1"
//                         variant="success"
//                       >
//                         {isUpdating && activeButton === "confirmed" ? (
//                           <Spinner
//                             as="span"
//                             animation="border"
//                             size="sm"
//                             role="status"
//                             aria-hidden="true"
//                           />
//                         ) : (
//                           "Confirmed"
//                         )}
//                       </Button>
//                       <Button
//                         onClick={() => handleStatusUpdate("delivered")}
//                         disabled={
//                           isUpdating || order?.status === "delivered"
//                         }
//                         className="mx-1"
//                       >
//                         {isUpdating && activeButton === "delivered" ? (
//                           <Spinner
//                             as="span"
//                             animation="border"
//                             size="sm"
//                             role="status"
//                             aria-hidden="true"
//                           />
//                         ) : (
//                           "Delivered"
//                         )}
//                       </Button>
//                       <Button
//                         onClick={() => handleStatusUpdate("onTheWay")}
//                         disabled={
//                           isUpdating || order?.status === "onTheWay"
//                         }
//                         variant="warning"
//                         className="mx-1"
//                       >
//                         {isUpdating && activeButton === "onTheWay" ? (
//                           <Spinner
//                             as="span"
//                             animation="border"
//                             size="sm"
//                             role="status"
//                             aria-hidden="true"
//                           />
//                         ) : (
//                           "On the Way"
//                         )}
//                       </Button>
//                       <Button
//                         onClick={() => handleStatusUpdate("cancelled")}
//                         variant="danger"
//                         disabled={
//                           isUpdating || order?.status === "cancelled"
//                         }
//                         className="mx-1"
//                       >
//                         {isUpdating && activeButton === "cancelled" ? (
//                           <Spinner
//                             as="span"
//                             animation="border"
//                             size="sm"
//                             role="status"
//                             aria-hidden="true"
//                           />
//                         ) : (
//                           "Cancelled"
//                         )}
//                       </Button>
//                     </div>
//                   </div>
//                 </Col>
//               </Row>
//             </Tab.Pane>

//             <Tab.Pane eventKey="recipe-details">
//               <Row>
//                 {/* Recipe Details */}
//                 <Col lg="12" className="my-4">
//                   <label className="form-label m-0 pb-2 ps-2 fw-sbold text-muted">
//                     Recipe Details
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0">
//                       {order?.data?.recipe?.map((step, index) => (
//                         <li key={index} className="py-2">
//                           <p className="m-0 fw-sbold themeClr">
//                             Step {index + 1}:
//                           </p>
//                           <p className="m-0 fw-sbold text-muted">
//                             {step}
//                           </p>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </Col>

//                 {/* cooking instruction */}
//                 <Col lg="12" className="my-4">
//                   <label className="form-label m-0 pb-2 ps-2 fw-sbold text-muted">
//                     Cooking Instruction
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <ul className="list-unstyled ps-0 mb-0">
//                       {order?.data?.cookingInstructions?.map(
//                         (step, index) => (
//                           <li key={index} className="py-2">
//                             <p className="m-0 fw-sbold themeClr">
//                               Step {index + 1}:
//                             </p>
//                             <p className="m-0 fw-sbold text-muted">
//                               {step}
//                             </p>
//                           </li>
//                         )
//                       )}
//                     </ul>
//                   </div>
//                 </Col>

//                 <Col lg="12" className="my-4">
//                   <label className="form-label m-0 pb-2 ps-2 fw-sbold text-muted">
//                     Ingredients
//                   </label>
//                   <div
//                     className="cardCstm px-lg-4 px-3 py-2 rounded"
//                     style={{ background: "#eee" }}
//                   >
//                     <table className="table table-bordered table-striped mb-0">
//                       <thead>
//                         <tr>
//                           <th className="themeClr">Sr. No.</th>
//                           <th className="themeClr">Name</th>
//                           <th className="themeClr">Quantity</th>
//                           <th className="themeClr">Unit</th>
//                           <th className="themeClr">Carbs (g)</th>
//                           <th className="themeClr">Fat (g)</th>
//                           <th className="themeClr">Protein (g)</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {order?.data?.ingredients.map(
//                           (ingredient, index) => (
//                             <tr key={ingredient._id}>
//                               <td>{index + 1}</td>
//                               <td>{ingredient.name}</td>
//                               <td>{ingredient.quantity}</td>
//                               <td>{ingredient.unit}</td>
//                               <td>{ingredient.macros.carbs}</td>
//                               <td>{ingredient.macros.fat}</td>
//                               <td>{ingredient.macros.protein}</td>
//                             </tr>
//                           )
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </Col>
//               </Row>
//             </Tab.Pane>
//           </Tab.Content>
//         </Tab.Container>
//       </Row>
//     )}
//   </Container>
// </section>

// )
